module.exports = __webpack_public_path__ + "static/media/avatar_2.11b7772f.jpg";